module.exports = __webpack_public_path__ + "img/offline.45956edc.png";